import { createEntityAdapter } from '@reduxjs/toolkit';
import { IEppDamperType } from 'application/components/api/EppDamperTerminal';

export const eppDamperTypeAdapter = createEntityAdapter<IEppDamperType, number>({
  selectId: (project) => project.eppDamperTypeID,
});
